import React, { Component, Fragment, useState } from "react";

import Api from "./../../helpers/apiHandler";
import { Link } from "react-router-dom";
import Popover from "../../components/uielements/popover";
import TopbarDropdownWrapper from "./topbarDropdown.style";
import authAction from "../../redux/auth/actions";
import { connect } from "react-redux";
import { Modal, Form, Input, message, Select, Menu, Dropdown, Icon } from "antd";
import userpic from "../../image/user1.png";
import varAction from "../../redux/variables/actions";
import awsPath, { basePath } from "../../helpers/awsPaths";
import userImg from "../../image/userimg11.png";
// import NotificationBadge from "../../components/notification/NotificationBadge";
import AppNotificationBadge from "../../components/notification/AppNotificationBadge";
import LocationDropdown from "../../components/uielements/LocationDropdown";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
const { logout } = authAction;
const { setRecipe } = varAction;

const api = new Api();
const FormItem = Form.Item;
class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      passwordModal: false,
      logOutModal: false,
      logoutLoading: false,
      resolvedProfileImage: userImg,
    };
  }
  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  handleLogout = () => {
    this.setState({ logoutLoading: true });
    let url = "user/logout";
    api
      .post(url)
      .then((response) => {
        if (response.status === 1) {
          this.props.setRecipe({});
          this.props.logout();
          this.props.socketData && this.props.socketData.disconnect();
          localStorage.clear();
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        this.setState({ logoutLoading: false });
      });
  };

  togglePasswordModal = () =>
    this.setState({ passwordModal: !this.state.passwordModal });

  toggleLogoutModal = () =>
    this.setState({ logOutModal: !this.state.logOutModal });

  componentDidMount() {
    this.resolveProfileImage();
  }

  componentDidUpdate(prevProps) {
    const prevProfileImage = prevProps.auth && prevProps.auth.profileImage;
    const currentProfileImage = this.props.auth && this.props.auth.profileImage;

    if (prevProfileImage !== currentProfileImage) {
      this.resolveProfileImage();
    }
  }
  loadImageWithRetry = (url, retries = 5, delay = 500) => {
    return new Promise((resolve, reject) => {
      const attempt = (n) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(url);
        img.onerror = () => {
          if (n > 0) {
            setTimeout(() => attempt(n - 1), delay);
          } else {
            reject(new Error("Failed to load image after retries"));
          }
        };
      };
      attempt(retries);
    });
  };
  resolveProfileImage = async () => {
    const profileImageKey = this.props.auth && this.props.auth.profileImage;
    if (profileImageKey) {
      const imageUrl = `${basePath}/${awsPath["originalImg"]}/${profileImageKey}`;
      try {
        await this.loadImageWithRetry(imageUrl);
        this.setState({ resolvedProfileImage: imageUrl });
      } catch (err) {
        console.error(err.message);
        this.setState({ resolvedProfileImage: userImg });
      }
    } else {
      this.setState({ resolvedProfileImage: userImg });
    }
  };
  render() {
    const profileImage =
      this.props.auth && this.props.auth.profileImage
        ? `${basePath}/${awsPath["originalImg"]}/${this.props.auth.profileImage}`
        : userImg;

    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        <a className="isoDropdownLink" onClick={this.hide}>
          <Link to="/companyDetails/companyData" style={{ color: "#595959" }}>
            Company Info
          </Link>
        </a>
        <a className="isoDropdownLink" onClick={this.hide}> 
          <Link to="/viewProfile" style={{ color: "#595959" }}>
            View My Profile
          </Link>
        </a>
        <a
          className="isoDropdownLink"
          onClick={() => {
            this.togglePasswordModal();
            this.hide();
          }}
        >
          Change Password
        </a>
        <a
          className="isoDropdownLink"
          onClick={() => {
            this.setState({ logOutModal: true });
            this.hide();
          }}
        >
          Logout
        </a>
      </TopbarDropdownWrapper>
    );
    return (
      <Fragment>
        <div className="display-flex flex-column align-end" style={{ gap: "9px" }}>
          <Popover
            content={content}
            trigger="click"
            visible={this.state.visible}
            onVisibleChange={this.handleVisibleChange}
            // arrowPointAtCenter={true}
            placement="bottomLeft"
          >
            {/* <div className="isoImgWrapper">
              <img alt="user" src={userpic} />
              <span className="userActivity online" />
            </div> */}
            <div className="display-flex align-center gap-10px">
              {/* <NotificationBadge socketData={this.props.socketData} /> */}
              <AppNotificationBadge />
              <h2 className="f-size-18px" style={{ color: "#fff" }}>
                {`${this.props.auth.firstName} ${this.props.auth.lastName}`}
              </h2>
              {this.props && this.props.auth && (
                <div className="profileImgWrapper">
                  <img
                    alt="user"
                    style={{ borderRadius: "99px", width: "100%" }}
                    src={this.state.resolvedProfileImage}
                  />
                  <span className="userActivity online" />
                </div>
              )}
            </div>
          </Popover>
          <LocationDropdown />
        </div>
        <LogoutModal
          visible={this.state.logOutModal}
          toggleModal={this.toggleLogoutModal}
          handleLogout={this.handleLogout}
          loading={this.state.logoutLoading}
        />
        <PasswordModal
          visible={this.state.passwordModal}
          toggleModal={this.togglePasswordModal}
        />
      </Fragment>
    );
  }
}

const WrapPasswordModal = (props) => {
  const [confirmDirty, setConfirmDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { form } = props;
  const handleConfirmBlur = (e) => {
    const { value } = e.target;
    setConfirmDirty(confirmDirty || !!value);
  };

  const compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue("newPassword")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };

  const validateToNextPassword = (rule, value, callback) => {
    if (value && confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  const handleSubmit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        setIsLoading(true);
        api
          .post("user/changePassword", {
            isMultipart: false,
            data: {
              oldPassword: values.oldPassword,
              newPassword: values.newPassword,
            },
          })
          .then((response) => {
            if (response.status === 1) {
              message.success(response.message);
              props.form.resetFields();
              props.toggleModal();
              setIsLoading(false);
            } else {
              message.error(response.message);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            return error;
          });
      }
    });
  };

  return (
    <Modal
      visible={props.visible}
      onCancel={props.toggleModal}
      title="Change password"
      okText="Reset"
      onOk={handleSubmit}
    >
      <Form {...formItemLayout} onSubmit={handleSubmit} labelAlign="left">
        <Form.Item label="Old password" hasFeedback>
          {form.getFieldDecorator("oldPassword", {
            rules: [
              {
                required: true,
                message: "Please old password!",
              },
              {
                validator: (_, value, callback) => {
                  if (!value || value.trim() === "") {
                    callback("Old password cannot be empty or just spaces!");
                  } else {
                    callback(); // Validation passed
                  }
                },
              },
            ],
          })(<Input.Password />)}
        </Form.Item>
        <Form.Item label="New Password" hasFeedback>
          {form.getFieldDecorator("newPassword", {
            rules: [
              {
                required: true,
                message: "Please input your password!",
              },
              {
                validator: (_, value, callback) => {
                  if (!value || value.trim() === "") {
                    callback("New password cannot be empty or just spaces!");
                  } else {
                    callback(); // Validation passed
                  }
                },
              },
              {
                validator: validateToNextPassword,
              },
            ],
          })(<Input.Password />)}
        </Form.Item>
        <Form.Item label="Confirm new password" hasFeedback>
          {form.getFieldDecorator("confirm", {
            rules: [
              {
                required: true,
                message: "Please confirm your password!",
              },
              {
                validator: compareToFirstPassword,
              },
            ],
          })(<Input.Password onBlur={handleConfirmBlur} />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const LogoutModal = (props) => {
  return (
    <Modal
      visible={props.visible}
      onCancel={props.toggleModal}
      title="Logout"
      okText="Yes"
      onOk={props.handleLogout}
      confirmLoading={props.loading}
    >
      <h2>Are you sure you want to logout?</h2>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  companyId: state.Auth.company.id,
  auth: state.Auth,
  socketData: state.Generals.socketData,
});

const PasswordModal = Form.create()(WrapPasswordModal);

export default connect(mapStateToProps, { logout, setRecipe })(TopbarUser);
